export const SECRET = 'WLpA3NHLk8a9Wy30hKuxU1M6cKCsSaF16QBiNVS7'
